﻿import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { api } from '../services/api';

export const Header: React.FC = () => {
  const location = useLocation();
  const [allowLiveResults, setAllowLiveResults] = useState(() => {
    const settings = api.getElectionSettingsSync();
    return settings.allowLiveResults !== false;
  });

  useEffect(() => {
    api.getElectionInfo().then((info) => {
      if (info) setAllowLiveResults(info.allowLiveResults !== false);
    });
  }, []);

  return (
    <div className="header">
      <div className="logo">
        <Link to="/">
          <img src="/assets/images/electpoll logo.png" alt="Electpoll Logo" />
        </Link>
      </div>
      <div className="navbar">
        <div className="nav-links">
          <div className={`nav-link ${location.pathname === '/' ? 'nl-active' : ''}`}>
            <Link to="/">
              <p>Voting</p>
            </Link>
          </div>
          {allowLiveResults && (
            <div className={`nav-link ${location.pathname === '/results' ? 'nl-active' : ''}`}>
              <Link to="/results">
                <p>Results</p>
              </Link>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
